type ArchiveCard<Job> = {
  currentMaps: readonly Job[];
  outsideMaps: readonly Job[];
};

export function getArchiveJobField<Field, Job extends { jobId: number | string }>(
  cards: readonly (ArchiveCard<Job> & { field: Field })[],
  job: Job
): Field | undefined {
  const card = cards.find(
    (entry) =>
      entry.currentMaps.some((entryJob) => entryJob.jobId === job.jobId) ||
      entry.outsideMaps.some((entryJob) => entryJob.jobId === job.jobId)
  );
  return card ? card.field : undefined;
}

export function getArchiveExportJobs<Job>(
  cards: readonly ArchiveCard<Job>[],
  selectedJobs: readonly Job[]
): Job[] {
  if (selectedJobs.length > 0) return [...selectedJobs];

  const jobs: Job[] = [];
  for (const card of cards) {
    jobs.push(...card.currentMaps, ...card.outsideMaps);
  }
  return jobs;
}

function escapeCsvCell(value: string | undefined): string {
  if (value === undefined) return '';
  if (!/[",\r\n]/.test(value)) return value;
  return '"' + value.replace(/"/g, '""') + '"';
}

export function createArchiveCsv<Job extends { createdDate: Date }>(
  jobs: readonly Job[],
  headers: readonly string[],
  formatRow: (job: Job) => readonly (string | undefined)[]
): string {
  const sortedJobs = [...jobs].sort((a, b) => a.createdDate.getTime() - b.createdDate.getTime());
  const rows = sortedJobs.map(formatRow);

  return [headers, ...rows].map((row) => row.map(escapeCsvCell).join(',')).join('\n');
}

export function createArchiveCsvFileName(
  seasonName: string,
  seasonLabel: string,
  downloadDate: string
): string {
  const safeSeasonName = seasonName.replace(/[<>:"/\\|?*\x00-\x1f]/g, '-');
  return `${seasonLabel.toLowerCase()}${safeSeasonName}_${downloadDate}.csv`;
}
